const metaData = {
  fields: [
    'id',
    'name',
    'paper_approver_id',
    'paper_id',
    'paper_smart_id',
    'paper_request_id',
    'is_disabled',
    { paper_request: ['name', 'paper_approver_id ', 'paper_setter_id', 'id', 'created_by'] },
    'paper_template_id',
    {
      paper_template: [
        'name',
        'id',
        'description',
        'sections',
        'test_track_id',
        {
          paper_template: [
            'name',
            'id',
            'section_id',
            'no_of_questions',
            'base_lang',
            'target_lang',
            'mark_per_question',
            'theme_id',
            'sub_theme_id',
            'report_theme_id',
            'subject_id',
            'topic_id',
            'section_id',
            'question_type_id',
            'blooms_level_id',
            'difficult_level_id',
            'strand_id',
            'competency_id',
            { question_type: ['id', 'name'] },
            { theme: ['id', 'name'] },
            { subject: ['id', 'name'] },
            { topic: ['id', 'name'] },
            { sub_theme: ['id', 'name'] },
            { report_theme: ['id', 'name'] },
            { section: ['id', 'name'] },
            { bloom_level: ['id', 'name'] },
            { difficulty_level: ['id', 'name'] },
            { competency: ['id', 'name'] },
            { strand: ['id', 'name'] },
          ],
        },
      ],
    },
    'product_id',
    { product: ['name', 'total_questions', 'total_marks','type'] },
    'test_track_id',
    { test_track: ['name', 'grade_ids', 'subject_ids'] },
    'test_event_id',
    { test_event: ['name'] },
    'sections',
    'status',
    'test_event_id',
    'updated_at',
    'updated_by',
    'created_by',
    'created_at',
    'status',
    'subSectionQuestions',
    'questionAnswerKeys',
    'flagged_questions',
    'approverFeedback',
    'rejectedQuestions',
    'slot_data',
    { work_requests: ['id', 'name', 'active'] },
    'active',
    'export_count',
    'parent_paper_id',
    { parent_paper: ['id', 'slot_data'] },
    'available_for_use',
    'current_paper_setter_id',
    { variant_papers: ['id', 'paper_id', 'paper_smart_id'] },
    { test_events_assigned: ['id', 'test_event_id', 'paper_id'] },
  ],
}

export default metaData
